var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1875 4.75H2.8125C1.25856 4.75 0 6.01637 0 7.5625V24.4375C0 25.9928 1.26781 27.25 2.8125 27.25H29.1875C30.7284 27.25 32 25.9981 32 24.4375V7.5625C32 6.01912 30.7464 4.75 29.1875 4.75ZM28.7936 6.625L17.9888 17.3729C17.4575 17.9042 16.7512 18.1967 16 18.1967C15.2487 18.1967 14.5425 17.9041 14.0095 17.3712L3.20637 6.625H28.7936ZM1.875 24.0559V7.94531L9.97738 16.005L1.875 24.0559ZM3.20756 25.375L11.3068 17.3273L12.6854 18.6987C13.5708 19.5841 14.7479 20.0717 16 20.0717C17.2521 20.0717 18.4292 19.5841 19.3128 18.7005L20.6933 17.3273L28.7924 25.375H3.20756ZM30.125 24.0559L22.0226 16.005L30.125 7.94531V24.0559Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/Contact Us.7c3cf12e3e8bd7bdeab7b3d0ba12beec.svg";
export { ForwardRef as ReactComponent };